<template>
  <div>
    <label class="flex items-center gap-[10px] cursor-pointer select-none">
      <div v-if="text" class="PC_Body1-R !text-[#1F1D1F]">
        {{ text }}
      </div>
      <div class="relative">
        <input type="checkbox" class="sr-only" @change="handleCheckboxChange" />
        <div
          :class="{ '!bg-[#68A134] !border-[#68A134]': isChecked }"
          class="h-[30px] w-[48.46px] rounded-full border-[2px] border-solid border-[#C7C7C7] bg-[##FCFCFC]"
        ></div>
        <div
          :class="{
            'translate-x-[19px] h-[20px] w-[20px] !bg-[#FCFCFC] border-[#FCFCFC]':
              isChecked,
          }"
          class="h-[18px] w-[18px] absolute left-[6px] top-[50%] translate-y-[-50%] flex items-center justify-center transition rounded-full bg-[#C7C7C7] border-[2px] border-solid border-[#C7C7C7]"
        ></div>
      </div>
      <div v-if="label" class="PC_Body1-R !text-[#1F1D1F]">
        {{ isChecked ? "กำลังใช้งาน" : "ปิดการใช้งาน" }}
      </div>
    </label>
    <StatusModal ref="statusModal0" @submit="confirm" />
  </div>
</template>
  
<script setup>
import { ref, watch, onMounted } from "vue";
// modal
const statusModal0 = ref(null);
// modal
const props = defineProps({
  text: {
    type: String,
  },
  active: {
    type: [Boolean, Number],
    required: true,
  },
  label: {
    type: Boolean,
    default: true,
  },
  validate: {
    type: Boolean,
    default: false,
  },
  validateStatus: {
    type: String,
    default: "warning",
  },
  validateSubHeader: {
    type: String,
    default: `หากปิดศูนย์พักพิง ข้อมูลผู้ประสบภัยทั้งหมด \n จะถูกย้ายไปยังข้อมูล ประชากร \n ท่านต้องการปิดทำการศูนย์หรือไม่ \n \n คำเตือน : หากปิดการใช้งาน \n นัดหมายที่เกี่ยวข้องกับศูนย์พักพิงแห่งนี้ \n จะถูกยกเลิกทั้งหมด โดยอัตโนมัติ \n และทรัพยากรคงเหลือจะถูกโอนย้ายไปยังศูนย์ \n กลางทั้งหมด`,
  },
  validateSubmitButton: {
    type: String,
    default: "ต้องการ",
  },
});

const isChecked = ref(props.active);
const emit = defineEmits(["toggleSlider"]);

watch(
  () => props.active,
  (newVal) => {
    isChecked.value = newVal == 2 ? 0 : 1;
  }
);

onMounted(async () => {
  isChecked.value = props.active == 2 ? 0 : 1;
});

const handleCheckboxChange = () => {
  if (props.validate && isChecked.value == 1) {
    statusModal0.value.openModal(props.validateStatus, {
      subHeader: props.validateSubHeader,
      submitButtonText: props.validateSubmitButton,
    });
  } else {
    isChecked.value = !isChecked.value;
    emit("toggleSlider", isChecked.value);
  }
};

const confirm = () => {
  isChecked.value = !isChecked.value;
  emit("toggleSlider", isChecked.value);
};
</script>
  
<style lang="scss" scoped>
@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}
</style>